export default __webpack_public_path__ + "static/media/63B44A49-2C19-4CF2-842B-B6C5B8AA5E3D.834f26b2.jpeg";